<template>
  <div class="catalog-page">
    <div class="container">
      <template v-if="!isComponent">
        <div class="catalog-page__breadcrumbs">
          <Breadcrumbs :breadcrumbs="breadcrumbs" />
        </div>
        <h1
          class="catalog-page__title h2"
          v-html="title"
        />
      </template>

      <template v-if="!isChildrenMenuCategories">
        <div
          v-if="isShowChildCategories"
        >
          <LightChildrenMenuCategoriesList
            :category="category"
          />
        </div>
        <div class="catalog-page__controls">
          <div class="--left">
            <button
              class="btn btn-primary btn-small --filter"
              :disabled="isLoadingFilters"
              @click="() => onChangeOpenFilter(true)"
            >
              <img
                src="~/assets/img/svg/common/filter.svg"
                alt="фильтр"
              />
              <span>Все фильтры</span>
            </button>
            <template
              v-for="(filterPage, index) in filterPages"
              :key="`button-${ index }`"
            >
              <nuxt-link
                :to="filterPage.url"
                class="btn btn-small btn-outline"
              >
                {{ filterPage.alt_title || filterPage.title }}
              </nuxt-link>
            </template>
          </div>
          <div class="--right">
            <div class="--total-count">{{ totalCountProducts }}</div>
            <SelectSort
              :value="state.sort"
              :options="sortOptions"
              @change="onChangeSort"
            />
          </div>
          <div
            v-if="Object.keys(selectedFilters).length > 0"
            class="--selected-filter"
          >
            <SelectedFilters
              :filters="filters"
              :selected="selectedFilters"
              :filter-price="filterPrice"
              @change="onChangeFilterAndSearchProduct"
            />
          </div>
        </div>
        <template v-if="Boolean(isVisibleLoadPre && Number.parseFloat(String(state.page || 0)) > 1)">
          <div class="catalog-page__pagination-pre">
            <button
              class="btn btn-outline btn-small"
              @click="onLoadPreProducts"
            >
              Показать предыдущие
            </button>
          </div>
        </template>
        <template v-if="isEmptyProducts">
          <div class="catalog-page__empty-products">Таких товаров не нашлось</div>
        </template>
        <div
          id="products-list"
          class="catalog-page__items"
          :class="{'--collection': isCollectionFirstProduct}"
        >
          <template
            v-for="(product, index) in products"
            :key="`product-${product.id}`"
          >
            <ProductCard
              v-if="!product.isProductSet"
              :product="product"
              :is-catalog="true"
              :page-product="Number.parseFloat(String(state.page || 0))"
            />
            <CollectionCard
              v-if="product.isProductSet"
              :product="product"
              :is-catalog="true"
              :page-product="Number.parseFloat(String(state.page || 0))"
            />

            <CardInformationDiscount
              v-if="isVisibleCardInformationDiscount(index)"
              :color="Boolean(index === 2) ? '#D3E6C6' : '#ECE2C9'"
            />

            <div
              v-if="isVisibleCardSocials(index)"
              class="wide-item"
            >
              <CardSocials />
            </div>
          </template>
          <template
            v-for="(item) in 7"
            :key="`catalog-page__loading-key-${item}`"
          >
            <div
              v-if="isLoadingProducts"
              class="--loading-card loading-skeleton"
            />
          </template>
        </div>
        <template v-if="pagination.pageCount > 1">
          <div
            ref="btnToScrollObserver"
            class="catalog-page__pagination"
          >
            <div class="--left">
              <button
                v-if="isVisibleLoadMore"
                class="btn btn-primary"
                @click="onLoadMoreProducts"
              >
                Загрузить еще
              </button>
            </div>
            <div class="--right">
              <Pagination
                :current-page="Number.parseFloat(String(state.page || 0))"
                :total-pages="Number.parseFloat(String(pagination.pageCount || 0))"
                @change="onChangePage"
              />
            </div>
          </div>
        </template>

        <SeoMicrodataCategoryProducts
          :category-name="title"
          :description="category?.description || category?.metaDescription || ''"
          :max-price="category?.productPriceTo || null"
          :count-products="pagination.totalCount"
          :image-id="products?.[0]?.imageId || null"
          :min-price="category?.productPriceFrom || null"
        />
      </template>
      <template v-if="isChildrenMenuCategories">
        <ChildrenMenuCategories
          :category="category"
        />
      </template>
    </div>

    <template v-if="!isChildrenMenuCategories && isVisibleFixedFilter">
      <div class="catalog-page__fixed-button-filter">
        <div class="container">
          <div
            ref="scrollContainer"
            class="catalog-page__fixed-button-filter-content"
            :class="{'scroll-customize-small': $viewport.isGreaterOrEquals('lg') }"

            @mousedown="startScroll"
            @mouseup="stopScroll"
            @mouseleave="stopScroll"
            @mousemove="onScroll"
          >
            <button
              class="btn btn-primary btn-small --filter"
              :disabled="isLoadingFilters"
              @click="() => onChangeOpenFilter(true)"
            >
              <img
                src="~/assets/img/svg/common/filter.svg"
                alt="фильтр"
              />
              <span>Все фильтры</span>
            </button>
            <template
              v-for="(filterPage, index) in filterPages"
              :key="`button-${ index }`"
            >
              <nuxt-link
                :to="filterPage.url"
                class="btn btn-small btn-outline"
              >
                {{ filterPage.alt_title || filterPage.title }}
              </nuxt-link>
            </template>
          </div>
        </div>
      </div>
    </template>

    <template v-if="relatedFilterPage">
      <RelatedFilterPage :items="relatedFilterPage" />
    </template>

    <ReviewsBlock cfgs="{}" extras="{}" :values="{heading: 'Отзывы'}"/>

    <template v-if="categorySeoTextFooter">
      <div class="catalog-page__category-seo-text cms-block-stub custom-section rm-pt">
        <div class="container">
          <div v-html="categorySeoTextFooter"/>
        </div>
      </div>
    </template>

    <DialogFilter
      v-if="isOpenFilter"
      :filters="filters"
      :filter-price="filterPrice"
      :selected-filters="selectedFilters"

      @close="(isUpdateFilter: boolean) => onChangeOpenFilter(false, isUpdateFilter)"
      @change="onChangeFilter"
    />
  </div>
</template>

<script lang="ts" setup>
import { useNuxtApp } from 'nuxt/app';
import type { ComputedRef } from 'vue';
import { useIntersectionObserver } from '@vueuse/core';
import { computed, defineAsyncComponent, onMounted, createError, ref, useRoute, onBeforeUnmount, watch } from '#imports';
import useSitisCategory from '#sitis/composables/useSitisCategory';
import Breadcrumbs from '~/components/UI/Breadcrumbs.vue';
import SelectSort from '~/components/catalog/SelectSort.vue';
import ProductCard from '~/components/catalog/ProductCard.vue';
import CollectionCard from '~/components/catalog/CollectionCard.vue';
import CardInformationDiscount from '~/components/catalog/CardInformationDiscount.vue';
import CardSocials from "~/components/catalog/card-socials/CardSocials.vue";
import { catalogStore as useCatalogStore } from '#sitis/stores/modules/catalog-store';
import { productStore as useProductStore } from '#sitis/stores/modules/product-store';
import sortProductsOptions from '~/constants/sort-products-options.json';
import { scrollToElement } from '~/utils/scrollToElement';
import useEcommerce from '~/composables/useEcommerceYandex';
import SeoMicrodataCategoryProducts from "~/components/common/SeoMicrodataCategoryProducts.vue";
import type {IRelatedFilterPage} from "~/types/catalogRelatedPage";

const Pagination = defineAsyncComponent(() => import('~/components/UI/Pagination.vue'));
const ReviewsBlock = defineAsyncComponent(() => import('~/cms/blocks/ReviewsBlock.vue'));
const DialogFilter = defineAsyncComponent(() => import('~/components/catalog/DialogFilter.vue'));
const SelectedFilters = defineAsyncComponent(() => import('~/components/catalog/SelectedFilters.vue'));
const ChildrenMenuCategories = defineAsyncComponent(() => import('~/components/catalog/ChildrenMenuCategories.vue'));
const LightChildrenMenuCategoriesList = defineAsyncComponent(() => import('~/components/catalog/light-children-menu-categories/LightChildrenMenuCategoriesList.vue'));
const RelatedFilterPage = defineAsyncComponent(() => import('~/components/catalog/RelatedFilterPage.vue'))

const {
  $viewport,
  $api
} = useNuxtApp();

interface IProps {
	isComponent?: boolean;
	isCancelApplyFilterToURL?: boolean;
	categorySlug?: string;
	defaultBasePathApi?: string;
  errorMessage?: string;
	initSelectedFilter?: any;
}

const props = withDefaults(defineProps<IProps>(), {
  isComponent: false,
  isCancelApplyFilterToURL: false,
  categorySlug: '',
  defaultBasePathApi: '',
  errorMessage: '',
  initSelectedFilter: () => ({})
});
const { addEcommerceProductsList } = useEcommerce();
const { setSEOTitles } = useSitisCMSPage();
const productStore = useProductStore();
const categorySlug: ComputedRef<string> = computed(() => props.categorySlug || '');
const {
  state,
  category,
  products,
  filters,
  filterInfo,
  pagination,

  getFilters,
  getCategory,
  getProducts,
  getFilterInfo,
  loadMoreProducts,
  initSelectedFilter,
  onClearProductsList,
  loadPreviousProducts,
  filterPages: apiFilterPages,

  initSaveMinMaxPage,

  changeSort,
  changeCurrentPage,
  changeSelectedFilterFull
} = useSitisCategory({
  defaultPerPage: 14,
  selectedFilter: props.initSelectedFilter || {},
  categorySlug: categorySlug.value,
  defaultBasePathApi: props.defaultBasePathApi || '',
  isCancelApplyFilterToURL: props.isCancelApplyFilterToURL,
  extensions: ['featuredFilterPages', 'short_characteristics', 'description', 'categories', 'children', 'promotions', 'promotions.icon']
});
const catalogStore = useCatalogStore();
const $route = useRoute();

const {
  $ym,
  $caseWords,
  $numberFormat
} = useNuxtApp();

const {
  data,
  refresh,
  pending,
  clear
} = await useLazyAsyncData('category-init', () => Promise.all([
  validationUrl(),
  getFilterInfo(),
]), { immediate: false });

const relatedFilterPage = ref<IRelatedFilterPage[]>([])
const loadRelatedFilterPage = async function () {
  if (category.value?.id) {
    try {
      const res = await $api.agent.get(`/related-filter-page?filter[category_id]=${category.value.id}`);
      relatedFilterPage.value = res._data || [];
    } catch (error) {
      console.error('Failed to load related filter page:', error);
      relatedFilterPage.value = [];
    }
  } else {
    relatedFilterPage.value = [];
  }
}

let debounceRefresh: any = null;
const normalizeBasePath = (path: string) => {
  const base = (path || '').split('/f/')?.[0] || '';
  return (base.split('?')?.[0] || '').replace(/\/$/, '');
};
const isAllowedCatalogPath = (basePath: string) => {
  const allowedPaths: string[] = ['/catalog', '/sets', '/akcii', '/catalogsearch'];
  return allowedPaths.some(prefix => basePath.startsWith(prefix));
};
const assertValidCategoryForRoute = (categoryData: any) => {
  const basePath = normalizeBasePath($route.path || '');
  if (!isAllowedCatalogPath(basePath)) {
    return;
  }

  if (categoryData?.url && categoryData.url !== basePath) {
    throw showError({
      statusCode: 404,
      message: props.errorMessage || 'Категория<br/>не найдена',
    });
  }

  const filterPage = (categoryData?.featuredFilterPages || []).find((t: any) => t.url === ($route.path || ''));
  if (filterPage?.hide_on_redirect) {
    throw showError({
      statusCode: 404,
      message: props.errorMessage || 'Категория<br/>не найдена.',
    });
  }
};
const validationUrl = async function() {
  const test: any = await getCategory();
  assertValidCategoryForRoute(test);
  category.value = test;
};
watch(() => normalizeBasePath($route.fullPath), async () => {
  clearTimeout(debounceRefresh)
  debounceRefresh = setTimeout(async () => {
    clear();
    initSelectedFilter();
    await refresh({ dedupe: 'cancel' });
    await getProducts();
    await loadRelatedFilterPage()
  }, 350)
});
await initCategories();
async function initCategories () {
  try {
    clear();
    initSelectedFilter();

    // Шаг 1: Валидация URL и проверка редиректов (БЛОКИРУЮЩАЯ)
    // refresh() вызывает validationUrl() + getFilterInfo() —
    // должен завершиться до рендера, т.к. может вызвать navigateTo() / showError()
    await refresh({ _initial: true, dedupe: 'cancel' });

    if (data.value && !pending.value) {
      assertValidCategoryForRoute(category.value);

      // Шаг 2: Загрузка товаров (НЕ БЛОКИРУЮЩАЯ)
      // Шаблон рендерится после шага 1, показывая скелетоны пока идёт загрузка
      await getProducts();
      loadRelatedFilterPage().catch(() => {});

      return;
    }
    throw createError({
      statusCode: 404,
      message: props.errorMessage || 'Категория<br/>не найдена',
      statusMessage: props.errorMessage || 'Категория<br/>не найдена'
    });
  } catch (err) {
    // showError / navigateTo выбрасывает исключение —
    // страница ошибки Nuxt уже активирована
  }
}


initSeoMeta();

// state
const isOpenFilter = ref(false);

// computed
const isLoadingProducts = computed(() => productStore.$state.loading);
const title = computed(() => {
  return filterInfo?.value?.h1 || filterInfo?.value?.filterPages?.[0]?.title || category?.value?.dynamicFields?.alt_title || category?.value?.title || category?.value?.name || category?.value?.title || ''
});
const breadcrumbs = computed(() => [
  { title: 'Главная', path: '/' },
  { title: 'Каталог', path: '/catalog' },
  { title: category.value?.name || category.value?.title, path: category.value?.url }
]);
const isVisibleLoadMore: ComputedRef<boolean> = computed(() => {
  if (isLoadingProducts.value) {
    return false
  }
  return Boolean((state.value?.page || 0) < pagination.value.pageCount)
});
const isEmptyProducts: ComputedRef<boolean> = computed(() => {
  return Boolean(!isLoadingProducts.value && products.value.length <= 0)
});

const sortOptions = computed(() => sortProductsOptions.options || []);
const totalCountProducts = computed(() => {
  const count = pagination.value?.totalCount || 0;
  const word = $caseWords(count, ['товар', 'товара', 'товаров']);
  return [$numberFormat(count), word].join(' ');
});

const filterPages = computed(() => {
  let _items = category.value?.featuredFilterPages || [];
  _items = _items.filter((t: any) => !Boolean(t.hide_on_redirect));
  return _items
});
const isCollectionFirstProduct = computed(() => Boolean(products.value?.[0]?.isProductSet));
const filterPrice = computed(() => {
// eslint-disable-next-line
	const filterPrices: { [key: string]: any } = catalogStore.filterPrices;
  return {
    min: filterPrices!.minPrice || 0,
    max: filterPrices!.maxPrice || 0
  };
});
const selectedFilters = computed(() => {
  const _selected: any = state.value.selectedFilter || {};
  delete _selected.text;
  return _selected;
});
const isLoadingFilters = computed(() => Boolean(catalogStore.$state.loading));

// functions
const onChangeFilter = async (newSelectedFilter: object) => {
  changeSelectedFilterFull(newSelectedFilter);
  await getFilters();

  productStore.onClearCurrentProductsStore();
  await getProducts();
  if (typeof $ym === 'function') {
    $ym('reachGoal', 'filter_apply');
  }

  await getFilterInfo();
};
const onChangeSort = async (sort: string) => {
  await changeSort(sort);
};

const onChangeOpenFilter = (val: boolean, isUpdateFilter?: boolean) => {
  isOpenFilter.value = val;
  if (val) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
};
const onLoadMoreProducts = async () => {
  if (Number.parseFloat(String(state.value.saveMaxPage || state.value.page || 1)) >= pagination.value.pageCount) {
    return;
  }
  await loadMoreProducts();
  const newProducts = products.value.slice(-(pagination?.value?.perPage || 0));
  addEcommerceProductsList(newProducts, `${title.value}` || 'Каталог');
};
const onLoadPreProducts = async () => {
  const firstProductId = products.value?.[0]?.id;
  await loadPreviousProducts();
  scrollToElement(`[data-product-id="${firstProductId}"]`, {
    offseetTop: window.innerHeight / 3
  });
  startPageNumber.value = Number.parseFloat(String(state.value.page || 1));
};

const isChildrenMenuCategories: ComputedRef<boolean> = computed(() => {
  return Boolean(category.value?.dynamicFields?.show_child_menu_categories);
});

const isShowChildCategories: ComputedRef<boolean> = computed(() => {
  return Boolean(category?.value?.dynamicFields?.show_child_categories)
})

const onChangePage = async (newPage: number) => {
  const productsListEl = document.getElementById('products-list');
  const headerEl = document.querySelector('.root-layout__header');
  if (productsListEl && headerEl) {
    const parentTop = productsListEl.getBoundingClientRect().top + window.pageYOffset;
    const headerHeight = headerEl.getBoundingClientRect().height;
    window.scrollTo({ top: parentTop - headerHeight, behavior: 'smooth' });
  }
  onClearProductsList();
  await changeCurrentPage(newPage);
};

const onChangeFilterAndSearchProduct = async (newSelectedFilter: object) => {
  productStore.onClearCurrentProductsStore();
  changeSelectedFilterFull(newSelectedFilter);
  await getProducts();
  await getFilters();
  await getFilterInfo();
};

const isVisibleLoadPre: ComputedRef<boolean> = computed(() => {
  return Boolean((state.value.saveMinPage || 1) > 1);
});

function initSeoMeta () {
  const currentPage = Number.parseFloat(String(state.value.page || 1));

  let title = filterInfo?.value?.filterPages?.[0]?.seo_title || apiFilterPages?.[0]?.seo?.title || filterInfo?.value?.seo_title || category.value?.seo?.title || category.value?.metaTitle || category.value?.title || '';
  if (title && currentPage > 1) {
    title = `${title} страница ${currentPage}`;
  }

  let description = filterInfo?.value?.filterPages?.[0]?.seo_description || apiFilterPages?.[0]?.seo?.description || filterInfo?.value?.seo_description || category.value?.seo?.description || category.value?.metaDescription || '';
  if (currentPage > 1) {
    description = `${description} страница ${currentPage}`;
  }

  const keywords = apiFilterPages?.[0]?.seo?.keywords || category.value?.seo?.keywords || category.value?.metaKeywords || '';

  setSEOTitles({
    seoTitle: title,
    seoDescription: description,
    seoKeywords: keywords
  });
}
watch(filterInfo, () => {
  initSeoMeta();
});

const startPageNumber: Ref<number> = ref(
  Number.parseFloat(String(state?.value?.page ?? 1)) || 1
);
const isVisibleCardInformationDiscount = (productIndex: number) => {
  const currentPage: number = Number.parseFloat(String(state.value.page || 0));
  if (currentPage === 1 && [2, 22].includes(productIndex)) {
    return true;
  }
  if (startPageNumber.value === 1 && [2, 22].includes(productIndex)) {
    return true;
  }
  return false;
};
const isVisibleCardSocials = (productIndex: number) => {
  const currentPage: number = Number.parseFloat(String(state.value.page || 0));
  if ( (currentPage === 1 || currentPage === 2) && productIndex === 10) {
    return true;
  }
  if (startPageNumber.value === 1 && productIndex === 10) {
    return true
  }
  return false
}

const btnToScrollObserver = ref<HTMLDivElement | null>();
const { stop } = useIntersectionObserver(
  btnToScrollObserver,
  async ([{ isIntersecting }]) => {
    if (!btnToScrollObserver.value || !isIntersecting || !isVisibleLoadMore.value) return;
    onLoadMoreProducts().catch(() => {});
  },
  { rootMargin: "60%" }
);

const isVisibleFixedFilter: Ref<boolean> = ref(false);
const eventScroll = (event: any) => {

  const headerHeight = document.querySelector('.header')?.getBoundingClientRect()?.height || 0;
  const topOffsetButtonFilter = document.querySelector('.catalog-page__controls .--filter')?.getBoundingClientRect()?.top || 0;
  const isHiddenButtonFilter = Boolean((topOffsetButtonFilter + headerHeight) < 0);
  if (isVisibleFixedFilter.value != isHiddenButtonFilter) {
    isVisibleFixedFilter.value = isHiddenButtonFilter;
  }
};

const scrollContainer: any = ref(null);
const isScrolling: any = ref(false);
const startX: any = ref(0);
const scrollLeft: any = ref(0);

const startScroll = (event: any) => {
  if (!scrollContainer.value) return;
  isScrolling.value = true;
  startX.value = event?.pageX - scrollContainer.value.offsetLeft;
  scrollLeft.value = scrollContainer.value.scrollLeft;
};

const stopScroll = () => {
  isScrolling.value = false;
};

const onScroll = (event: any) => {
  if (!isScrolling.value || !scrollContainer.value) {
    return;
  }
  event.preventDefault();
  const x = event.pageX - scrollContainer.value.offsetLeft;
  const walk = (x - startX.value) * 2; // Скорость прокрутки
  scrollContainer.value.scrollLeft = scrollLeft.value - walk;
};

const categorySeoTextFooter: ComputedRef<string> = computed(() => {
  return category?.value?.description || category?.value?.dynamicFields?.bottom_text || filterInfo?.value?.filterPages?.[0]?.bottom_text || ''
});

onBeforeUnmount(() => {
  stop();

  if (window && window?.removeEventListener) {
    window.removeEventListener('scroll', eventScroll);
  }
});
onMounted(async () => {
  initSaveMinMaxPage();
  await getFilters();
  addEcommerceProductsList(products.value, `${title.value}` || 'Каталог');
  if (window && window?.addEventListener) {
    window.addEventListener('scroll', eventScroll);
  }
});
</script>

<style lang="scss">
.catalog-page__breadcrumbs {
	.breadcrumbs-custom {
		padding-top: 18px;
	}
}

.catalog-page__title {
	margin-top: 12px;
}

.catalog-page__controls {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	flex-wrap: wrap;
	margin-top: 32px;
	margin-bottom: 32px;

	.--left {
		display: flex;
		flex-wrap: wrap;
		margin-top: -16px;
		margin-left: -16px;
		flex: 1;

		& > * {
			margin-top: 16px;
			margin-left: 16px;
		}
	}

	.--right {
		display: flex;
		align-items: center;
		padding: 11px 0;
	}

	.--selected-filter {
		width: 100%;
		margin-top: 16px;
	}

	.--filter {
		display: flex;
		align-items: center;

		img {
			margin-right: 9px;
		}
	}

	.--total-count {
		margin-right: 16px;
		opacity: 0.5;
		color: #000;
		font-size: 16px;
		font-weight: 500;
		line-height: 100%;
	}
}

.catalog-page__items {
	display: flex;
	flex-wrap: wrap;
	margin-top: -64px;
	margin-left: -32px;

	& > * {
		width: calc(100% / 4 - 32px);
		margin-top: 64px;
		margin-left: 32px;

    &.wide-item {
      width: calc(100% / 2 - 32px);
    }
  }

	.--loading-card {
		height: 360px;
		border-radius: 20px;
		overflow: hidden;
	}
}

.catalog-page__pagination-pre {
	margin-bottom: 32px;
	position: relative;
	z-index: 1;

	.btn {
		width: 100%;
	}
}

.catalog-page__pagination {
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	margin-top: 80px;
	position: relative;
	z-index: 10;

	.btn {
		padding: 10px 22px;
		border-radius: 8px;
		background-color: #F4F3F1;
		color: #000;
	}
}

.catalog-page__fixed-button-filter {
  position: fixed;
  z-index: 5;
  top: 127px;
  left: 0; right: 0;
  padding: 10px 0;
  box-sizing: border-box;
  background: white;
}
.catalog-page__fixed-button-filter-content {
  display: flex;
  flex-wrap: nowrap;
  overflow: auto;

  gap: 10px;
  padding-bottom: 5px;
  margin-bottom: -4px;

  & > * {
    white-space: nowrap;
    height: 32px;
  }
  .--filter {
    gap: 8px;
    img {
      min-width: 20px;
    }
  }
  .btn-outline {
    background: white;
    border-radius: 8px;
    padding: 8px 24px 6px;

    &:hover {
      background: #F4F3F1;
    }
    &:active {
      background: #404040;
      border-color: #404040;
    }
  }
}

.catalog-page__empty-products {
  font-weight: 600;
  font-size: 32px;
  line-height: 125%;
  margin-top: 40px;
}

.catalog-page__category-seo-text {
  color: #989898;
  h1 {
    color: #989898;
  }
  h2 {
    color: #989898;
    font-family: Gilroy;
    font-size: 24px;
    font-weight: 500;
    line-height: 130%;
    &.semibold {
      font-weight: 600;
    }
  }
  h3 {
    color: #989898;
  }
}

@media (max-width: 1699px) {
	.catalog-page__items > * {
		width: calc(100% / 3 - 32px);
    &.wide-item {
      width: calc(100% / 1.5 - 32px);
    }
  }
}

@media (max-width: 1359px) {
	.catalog-page__items > * {
		width: calc(100% / 2 - 32px);
    &.wide-item {
      width: calc(100% / 2 - 32px);
    }
	}
}

@media screen and (max-width: 1199px) {
  .catalog-page__fixed-button-filter {
    top: 117px;
  }
}

@media (max-width: 1023px) {
	.catalog-page {
		padding-top: 20px;
		box-sizing: border-box;
	}
	.catalog-page__breadcrumbs {
		display: none;
	}
	.catalog-page__controls {
		flex-direction: column;
		margin-top: 17px;
		margin-bottom: 16px;
		padding-bottom: 17px;
		border-bottom: 1px solid #F4F3F1;

		.--left {
      overflow: auto;
      flex-wrap: nowrap;
			flex: initial;
			width: 100%;
      padding-bottom: 10px;
      margin-bottom: -10px;
      margin-top: -10px;
      margin-left: -10px;

      .btn-outline {
        padding: 6px 24px 4px;
        white-space: nowrap;
      }
      & > * {
        margin-top: 10px;
        margin-left: 10px;
      }
		}

		.--right {
			justify-content: space-between;
			width: 100%;
			padding: 0;
			margin-top: 22px;
		}

		.--filter {
			padding: 0 23px;
			height: 32px;

			img {
				margin-right: 0;
        min-width: 20px;
			}

			span {
				display: none;
			}
		}

		.--total-count {
			font-size: 12px;
		}
	}
	.catalog-page__pagination {
		margin-top: 32px;

		.--left {
			width: 100%;
		}

		.--right {
			display: none;
		}

		.btn {
			height: 48px;
			width: 100%;
			background: transparent;
			border: 1px solid #404040;
			border-radius: 12px;
		}
	}
	.catalog-page__pagination-pre {
		margin-bottom: 20px;
	}
  .catalog-page__fixed-button-filter {
    top: 77px;
    .--filter img {
      margin: 0;
    }
    .--filter span {
      display: none;
    }
  }
  .catalog-page__controls .--left {
    width: calc(100% + 40px);
    margin: 0 -20px;
    margin-bottom: -10px;
    padding: 0 20px;
    padding-bottom: 10px;
    box-sizing: border-box;
    .--filter {
      margin-left: 0;
    }
  }
  .catalog-page__fixed-button-filter-content {
    width: calc(100% + 40px);
    margin: 0 -20px;
    margin-bottom: -10px;
    padding: 0 20px;
    padding-bottom: 10px;
  }
  .catalog-page__category-seo-text {
    h2 {
      font-size: 20px;
    }
  }
}

@media (max-width: 859px) {
	.catalog-page__items {
		margin-top: -16px;
		margin-left: -16px;

		& > * {
			width: calc(100% / 2 - 16px);
			margin-top: 16px;
			margin-left: 16px;
		}
	}
  .catalog-page__controls .--left {
    width: calc(100% + 20px);
    margin: 0 -10px;
    margin-bottom: -10px;
    padding: 0 10px;
    padding-bottom: 10px;
  }
  .catalog-page__fixed-button-filter-content {
    width: calc(100% + 20px);
    margin: 0 -10px;
    margin-bottom: -10px;
    padding: 0 10px;
    padding-bottom: 10px;
  }
}

@media (max-width: 639px) {
	.catalog-page__items {
		& > * {
			width: calc(100% - 16px);
      &.wide-item {
        width: calc(100% - 16px);
      }
		}
	}
  .catalog-page__controls .--left {
    width: calc(100% + 40px);
    margin: 0 -20px;
    margin-bottom: -10px;
    padding: 0 20px;
    padding-bottom: 10px;
  }
  .catalog-page__fixed-button-filter-content {
    width: calc(100% + 40px);
    margin: 0 -20px;
    margin-bottom: -10px;
    padding: 0 20px;
    padding-bottom: 10px;
  }
}
</style>
